import gql from "graphql-tag"

export const GET_ORDER_HISTORIES = gql`
  query OrderHistories(
    $take: Int
    $skip: Int
    $input: OrderHistoryFilterInput
  ) {
    orderHistories(take: $take, skip: $skip, input: $input) {
      total
      data {
        id
        order {
          id
          orderNumber
          company {
            id
            name
          }
          user {
            id
            name
          }
        }
        description
        creator {
          id
          name
        }
        createdAt
      }
    }
  }
`

export const SUM_ORDER_HISTORIES = gql`
  query OrderHistories($input: OrderHistoryFilterInput) {
    orderHistories(take: 0, input: $input) {
      total
    }
  }
`

export const GET_TABLE_FIELDS = gql`
  query OrderHistoryFields {
    aorderHistoryFields @client {
      name
      title
      order
      show
    }
  }
`
